// Modules
import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
// import { FormattedMessage } from 'react-intl';
import Head from 'next/head';
import Link from 'next/link';
import { useInView } from 'react-intersection-observer';
// Components
import Breadcrumbs from '~/components/breadcrumbs';
import LoadMore from '~/components/load-more';
import CategoryPageTitle from '~/components/category-page-title';
import CategoryInfo from '~/components/category-info';
// import FilterButton from '~/components/filter-button';
// import SortButton from '~/components/sort-button';
// import DesktopFilter from '~/components/desktop-filter';
import SubcategoryPostCard from '~/components/subcategory-post-card';
// Utils
import { useCategoryPosts } from '~/hooks/use-request';
import { isEmpty } from '~/utils';
// Icons
// import SortIcon from '~/assets/images/sort.svg';
// Styles
import styles from './subcategory-page.module.scss';

const SubcategoryPage = ({ slug, categoryResponse, categoryPostsResponse }) => {
  const { ref, inView } = useInView();

  const { cover_image, alt_cover_image, title, content, parent } = categoryResponse;

  const response = useCategoryPosts({
    categoryPostsResponse,
    slug,
  });

  const { data, fetchNextPage, hasNextPage, isFetchingNextPage, status } = response;

  useEffect(() => {
    if (inView && hasNextPage) {
      fetchNextPage();
    }
  }, [inView, fetchNextPage, hasNextPage]);

  const collectionPageScheme = JSON.stringify({
    '@context': 'https://schema.org/',
    '@type': 'CollectionPage',
    name: title,
    url: `${process.env.SITE_URL}/category/${slug}/`,
    breadcrumb: {
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: 'خانه',
          item: `${process.env.SITE_URL}/`,
        },
        {
          '@type': 'ListItem',
          position: 2,
          name: parent?.title,
          item: `${process.env.SITE_URL}/category/${parent?.slug}/`,
        },
        {
          '@type': 'ListItem',
          position: 3,
          name: title,
          item: `${process.env.SITE_URL}/category/${slug}/`,
        },
      ],
    },
    mainEntity: {
      '@type': 'ItemList',
      itemListOrder: 'https://schema.org/ItemListOrderUnordered',
      itemListElement: data?.pages[0]?.map((item) => ({
        '@type': 'ListItem',
        item: {
          '@type': 'VideoObject',
          name: item.title,
          thumbnailUrl: item.cover_image || item.cover_image_url,
          description: item.content,
          uploadDate: item.created_at,
          contentUrl: item.download_link_720,
        },
      })),
    },
  });

  return (
    <>
      <Head>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: collectionPageScheme }}
        />
      </Head>

      <div className="container">
        <div className={styles['wrapper']}>
          <Breadcrumbs
            items={[
              {
                label: <FormattedMessage id="apron.plus.main_page" />,
                path: `/`,
              },
              { label: parent?.title, path: `/category/${parent?.slug}` },
            ]}
          />
          <CategoryPageTitle
            coverImage={cover_image}
            altCoverImage={alt_cover_image}
            title={title}
          />

          {/* <div className={`${styles['wrapper__filter-sort']} hidden-lg-up`}>
            <FilterButton />
            <SortButton />
          </div> */}

          <div className={styles['wrapper__content']}>
            {/* <div className={`${styles['wrapper__content__filter-side']} hidden-lg-down`}>
              <DesktopFilter />
            </div> */}

            <div className={styles['wrapper__content__main']}>
              {/* <div className={`${styles['wrapper__content__main__sort']} hidden-lg-down`}>
                <SortIcon />
                <button>
                  <FormattedMessage id="apron.plus.sort.newest" />
                </button>
                <button>
                  <FormattedMessage id="apron.plus.sort.favorite" />
                </button>
              </div> */}

              <div className={styles['wrapper__content__main__posts']}>
                {data?.pages?.map((page, i) => (
                  <React.Fragment key={i}>
                    {page?.map((item) => (
                      <Link key={item.id} href={`/video/${item.slug}/`} title={item.title}>
                        <SubcategoryPostCard item={item} />
                      </Link>
                    ))}
                  </React.Fragment>
                ))}
              </div>
            </div>
          </div>

          <LoadMore
            refProp={ref}
            onClick={() => fetchNextPage()}
            hasNextPage={hasNextPage}
            isFetchingNextPage={isFetchingNextPage}
            status={status}
            autoRequest={false}
            route={`category/${slug}`}
          />
        </div>
      </div>
      {!isEmpty(content) && <CategoryInfo data={content} />}
    </>
  );
};

export default SubcategoryPage;
